<template>
<div id="app">
    <router-view></router-view>

    <b-container fluid class="text-center" style="margin: 30px 0px 30px 0px;">
        <b-row>
            <b-col sm="12">
                <a href="http://www.het.it">
                    <b-img :src="require('./assets/logohet.png')" style="width: 75px;" />
                </a>
            </b-col>
            <b-col sm="12" class="my-3" style="color: #696969;">
                <span>{{"AppCral versione" + " " + versione}}</span><br>
                <span>{{'© 2019 H&T S.r.l. P.IVA IT04378100483 - Tutti i diritti riservati'}}</span>
            </b-col>
        </b-row>
    </b-container>
</div>
</template>

<script>
import {
    VERSION
} from './config.js'

export default {
    name: 'app',
     data: function () {
        return {
            versione: VERSION
        };
    }
}
</script> 
 
 <!-- <template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/>
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'app',
  components: {
    HelloWorld
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style> -->
